import { useMemo } from 'react';
import Link from 'next/link';
import BlogListItemContent from '../BlogListItemContent';

function FeaturedBlog({ item, cssClassName = '', isLoading }) {
    const content = useMemo(
        () => (
            <div className="flex flex-col md:flex-row justify-start items-center pt-6 gap-4 lg:gap-8">
                <Link href={`/blogs/${item?.slug}`} legacyBehavior>
                    <figure className="rounded-3xl h-[210px] w-[350px] lg:h-[220px] lg:w-[383px] xl:h-[288px] xl:w-[452px] object-cover cursor-pointer">
                        {isLoading ? (
                            <div className="h-full w-full skeleton-loader mb-6 rounded-3xl"></div>
                        ) : (
                            <img
                                src={item.featuredImage?.node?.mediaItemUrl}
                                alt="featureBlogImage"
                                className="h-full w-full rounded-3xl object-cover"
                            />
                        )}
                    </figure>
                </Link>

                <div className="flex-1 px-4 lg:px-8 py-1 flex flex-col justify-center">
                    <BlogListItemContent
                        item={item}
                        isLoading={isLoading}
                        isFeaturedBlogContent={true}
                    />
                </div>
            </div>
        ),
        [item, isLoading]
    );

    return !isLoading ? (
        <div className={cssClassName} key={item.id}>
            {content}
        </div>
    ) : (
        <div className={cssClassName}>{content}</div>
    );
}

export default FeaturedBlog;
